// extracted by mini-css-extract-plugin
module.exports = {"statusColumn":"TermsAndConditionsList_statusColumn_1qmi8","actionColumn":"TermsAndConditionsList_actionColumn_3IYUX","ellipsisColor":"TermsAndConditionsList_ellipsisColor_3OX-w"};